import { Typography } from '@p2p/components';
import { getClientBankNameGenitive } from '@p2p/entities/qrInvoice/clientBankName';
import { TGetOrderResponse } from '@p2p/services';
import { memo, useMemo } from 'react';
import QRCode from 'react-qr-code';

import styles from './QRCodeInvoice.module.scss';
import { getQrInvoiceSource } from './qrInvoiceSource';

type QrCodeInvoiceProps = {
  order: TGetOrderResponse;
  randomId: string;
};

export const QrCodeInvoice = memo(
  ({ order, randomId }: QrCodeInvoiceProps) => {
    // Какой QR показать (ссылка провайдера, готовая строка, картинка, шаблон банка) -
    // см. getQrInvoiceSource (P2P-3116: те же правила на странице alfa_page).
    const source = useMemo(() => getQrInvoiceSource(order, randomId), [order, randomId]);

    if (!source) {
      return null;
    }

    // P2P-3048: банк плательщика в подписи под QR (только реквизит с qr_invoice).
    const bankName = getClientBankNameGenitive(order) ?? 'банка';

    return (
      <div className={styles.container}>
        <div className={styles.qrContainer}>
          {source.kind === 'image' ? (
            <img src={source.src} width={160} height={160} alt="QR-код для оплаты" />
          ) : (
            <QRCode value={source.value} size={160} />
          )}
        </div>
        <Typography variant="text-l-medium">
          Откройте приложение {bankName} <br /> и в нем отсканируйте QR-код.
        </Typography>
      </div>
    );
  },
  (prevProps, nextProps) => prevProps.order.id === nextProps.order.id,
);
